export default {
    order: {},
    productTemplates: [],
    deliveryFile: null,
    cancelToken: null
}